import { apiUrl } from '../config/config'
import { error as logError } from '../utils/logger'
import { sendRequest } from '../utils/FetchServices'

export const save_assessment_progress = async (data, data_update_devices_users) => {
    const URL = apiUrl + '/save_assessment_progress'

    try {
        let headers = {
            Authorization: data.authToken,
            evaluation_id: data.evaluation_id,
            course_id: data.course_id,
            content_id: data.content_id,
            ...(data.attempt_id ? { attempt_id: data.attempt_id } : {}),
        }
        let body = {
            answers: data.answers,
        }
        const data_resp = await sendRequest(URL, 'POST', headers, body, 0, 25)

        console.log('🚀/////1~ responseData evaluation:', data_resp)
        // Invalidar caché del servidor para que el próximo fetch traiga datos frescos
        if (data_update_devices_users) {
            try {
                await update_devices_users(data_update_devices_users)
            } catch (e) {
                console.warn('update_devices_users after save_assessment failed:', e)
            }
        }
        return data_resp
        // const response = await fetch(`${apiUrl}/save_assessment`, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         Authorization: data.authToken,
        //         evaluation_id: data.evaluation_id,
        //         course_id: data.course_id,
        //         content_id: data.content_id,
        //     },
        //     body: JSON.stringify({
        //         answers: data.answers,
        //     }),
        // })

        //console.log('eeeeerrrrrorrr constsave_assessment_request= ~ response:', response)
        // if (!response.ok) {
        //     throw new Error('Fallo save_assessment')
        // }
        // let responseData = await response.json()
        // console.log('🚀/////1~ responseData evaluation:', responseData)
        // if (data_update_devices_users) {
        //     await update_devices_users(data_update_devices_users)
        // }
        // return responseData
    } catch (error) {
        logError('NotificationService', 'notification_status_change failed', error)
        throw new Error('111 error en save_assessment_progress: ', error)
    }
}

export const update_devices_users = async (data) => {
    const URL = apiUrl + '/update_devices_users'

    try {
        let headers = {
                'Content-Type': 'application/json',
                Authorization: data.authToken,
                device_key: data.device_key,
                table: data.table,
            }
        const data_resp = await sendRequest(URL, 'GET', headers, null, 0, 25)
        return data_resp
        
    } catch (error) {
        logError('141 Error en update_devices_users:', error)
        throw error
    }
}

